var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 183,
    height: 183,
    viewBox: "0 0 183 183",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.042,
    x2: 0.976,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4905b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb6a23"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Play",
    transform: "translate(-1168 -2850)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse",
    cx: 91.5,
    cy: 91.5,
    r: 91.5,
    transform: "translate(1168 2850)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_Play",
    "data-name": "Icon Play",
    d: "M83.85,1.5A82.35,82.35,0,1,0,166.2,83.85,82.337,82.337,0,0,0,83.85,1.5Zm33.178,83.894L62.708,118.255a1.761,1.761,0,0,1-2.653-1.544V50.989a1.754,1.754,0,0,1,2.653-1.544l54.319,32.861A1.815,1.815,0,0,1,117.028,85.394Z",
    transform: "translate(1175.65 2857.65)",
    fill: "url(#linear-gradient)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/Play.1e97107919669d903a0ff790c0ce3e93.svg";
export { ForwardRef as ReactComponent };